import { Injectable, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { COVARIATE_TAB, DISEASES_TAB, GEONETWORK_URL, HeaderTool } from './header.model';

@Injectable({ providedIn: 'root' })
export class HeaderFacade {
  private _router: Router = inject(Router);
  // private _geonetwork: GeonetworkFacade = inject,

  private readonly baseTools: HeaderTool[] = [
    {
      label: 'Covariates',
      route: 'core',
      params: { tab: COVARIATE_TAB },
    },
    {
      label: 'Diseases',
      route: 'core',
      params: { tab: DISEASES_TAB },
    },
    {
      label: 'GeoNetwork',
      route: 'https://mood-geonetwork.avia-gis.com/geonetwork/srv/eng/catalog.search',
      external: true,
    },
    {
      label: 'PADI-web',
      route: 'https://padi-web.cirad.fr/en/',
      external: true,
    },
  ];

  private readonly adminTool: HeaderTool = {
    label: 'Dataset admin',
    route: 'admin',
  };

  private isAdmin = signal(false);

  readonly tools = computed(() => {
    return this.isAdmin() ? [...this.baseTools, this.adminTool] : this.baseTools;
  });

  // readonly geonetworkServices = computed(() => this.geonetwork.services(DEFAULT_CATEGORIES));
  //
  // readonly geonetworkSoftware = computed(() => this.geonetwork.software(DEFAULT_CATEGORIES));

  constructor() {
    // this._auth.isAdmin$.subscribe((isAdmin) => this.isAdmin.set(isAdmin));
  }

  openTool(tool: HeaderTool) {
    if (tool.external) {
      window.open(tool.route, '_blank');
    } else {
      this._router.navigate([tool.route], {
        queryParams: tool.params,
      });
    }
  }

  openGeonetworkTool(identifier: string) {
    window.open(`${GEONETWORK_URL}${identifier}`, '_blank');
  }
}
